/* eslint-disable no-unused-vars */
/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getList({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(`course-classes?${new URLSearchParams(param)}`)
        .then((response) => {
          commit("SET_LIST", response.data.data);
          commit("CLASS_FILTER", response.data.data);
          commit("TIMETABLES_FILTER", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  getListWithoutState({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(`course-classes?${new URLSearchParams(param)}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDetail({ commit }, { id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`course-classes/${id}?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  addClass({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("course-classes", payload)
        .then((response) => {
          commit("ADD_CLASS", response.data.data);
          commit("CLASS_FILTER");
          commit("TIMETABLES_FILTER");
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateClass({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`course-classes/${id}`, payload)
        .then((response) => {
          commit("UPDATE_CLASS", response.data.data);
          commit("CLASS_FILTER");
          commit("TIMETABLES_FILTER");
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateClassStatus({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`course-classes/${id}/statuses`, payload)
        .then((response) => {
          commit("UPDATE_CLASS", response.data.data);
          commit("CLASS_FILTER");
          commit("TIMETABLES_FILTER");
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  refreshLessons({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`course-classes/${id}/refresh-lessons`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  syncTimetables({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`course-classes/${id}/sync-timetables`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateTimetables({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`course-timetables/${id}`, payload)
        .then((response) => {
          commit("UPDATE_CLASS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  patchUpdateTimetables({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`course-timetables/${id}`, payload)
        .then((response) => {
          commit("UPDATE_CLASS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  async deleteMultiple({ commit }, payload) {
    return await axios.post("course-classes/delete-multiple", payload, {
      headers: { "Content-Type": "application/json" },
    });
  },

  // eslint-disable-next-line no-unused-vars
  importExcel({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post("course-classes/import", data, {
          headers: { "content-type": "multipart/form-data" },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },

  setFilters({ commit }, data) {
    commit("SET_FILTERS", data);
    commit("CLASS_FILTER");
    commit("TIMETABLES_FILTER");
  },
};
